var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","width":"100%"}},[_c('div',{staticStyle:{"width":"700px","height":"500px"},attrs:{"id":"renew"}}),_c('div',{staticStyle:{"width":"700px","height":"500px"},attrs:{"id":"ContinuedCharging"}})])])
}]

export { render, staticRenderFns }